import { render } from "./Notif.vue?vue&type=template&id=02212658"
import script from "./Notif.vue?vue&type=script&lang=js"
export * from "./Notif.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__